import { render, staticRenderFns } from "./RequestCreate.vue?vue&type=template&id=35f9639e&scoped=true&"
import script from "./RequestCreate.vue?vue&type=script&lang=js&"
export * from "./RequestCreate.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreate.vue?vue&type=style&index=0&id=35f9639e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9639e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f9639e')) {
      api.createRecord('35f9639e', component.options)
    } else {
      api.reload('35f9639e', component.options)
    }
    module.hot.accept("./RequestCreate.vue?vue&type=template&id=35f9639e&scoped=true&", function () {
      api.rerender('35f9639e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/RequestCreate.vue"
export default component.exports